'use client';
import React from 'react';

const stats = [
  {
    value: '50+',
    label: 'security engagements',
    description: 'Compliance programmes, AppSec assessments, threat modelling, and continuous DevSecOps engagements delivered across regulated industries.',
  },
  {
    value: '100%',
    label: 'SENIOR ENGINEERS',
    description: 'Every engagement is led and delivered by senior security engineers. No juniors, no automated-only tooling, no box-ticking reports that gather dust.',
    highlight: true,
  },
  {
    value: '365',
    label: 'days a year',
    description: 'Continuous, embedded security coverage, not point-in-time audits. We stay active so your posture never lapses between compliance windows.',
  },
];

export default function StatsSection() {
  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28 relative overflow-hidden">
      {/* Background orb */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="orb orb-cyan" style={{ width: '400px', height: '400px', top: '-100px', right: '10%', opacity: 0.5 }} />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12">
        <p className="fade-in-up font-mono-brand text-[0.7rem] text-[#80edfa] uppercase tracking-widest mb-4">
          Why TechSonar
        </p>
        <h2 className="fade-in-up font-heading text-[clamp(2rem,4vw,3.5rem)] text-[#f5f5f8] font-medium mb-16 max-w-2xl" style={{ transitionDelay: '0.1s' }}>
          Highly qualified engineers. Meaningful impact. Every day.
        </h2>

        <div className="stagger-children grid grid-cols-1 lg:grid-cols-3 gap-0 border-t border-[#222]">
          {stats?.map((stat, i) => (
            <div
              key={i}
              className={`py-10 lg:py-12 shimmer-hover transition-all duration-300 ${
                i < stats?.length - 1 ? 'border-b lg:border-b-0 lg:border-r border-[#222]' : ''
              } ${i > 0 ? 'lg:pl-12' : ''} ${i < stats?.length - 1 ? 'lg:pr-12' : ''}`}
            >
              {stat?.highlight ? (
                <div className="flex flex-col gap-4">
                  <div className="w-full h-px bg-gradient-to-r from-[#80edfa] to-transparent mb-2" />
                  <p className="font-mono-brand text-[0.7rem] text-[#80edfa] uppercase tracking-widest">
                    {stat?.label}
                  </p>
                  <p className="text-sm text-[#aaa] leading-relaxed">{stat?.description}</p>
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  <div className="stat-number gradient-text-animate">{stat?.value}</div>
                  <p className="font-mono-brand text-[0.7rem] text-[#666] uppercase tracking-widest">
                    {stat?.label}
                  </p>
                  <p className="text-sm text-[#aaa] leading-relaxed">{stat?.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
